export const IS_CREATING_ES_KEY = 'isCreating';
export const IS_CREATING_ES_INVOICE_KEY = 'isCreatingInvoice';
export const IS_SAVED_ES_INVOICE_KEY = 'isInvoiceSaved';
